'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('../../../shared/prop-types');

var _feedItemContainer = require('../feed-item-container');

var _feedItemContainer2 = _interopRequireDefault(_feedItemContainer);

var _feedItemMessage = require('../feed-item-message');

var _feedItemMessage2 = _interopRequireDefault(_feedItemMessage);

var _sharedVideo = require('./shared-video');

var _sharedVideo2 = _interopRequireDefault(_sharedVideo);

require('./_video-feed-item.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoFeedItem = function (_PureComponent) {
  _inherits(VideoFeedItem, _PureComponent);

  function VideoFeedItem() {
    _classCallCheck(this, VideoFeedItem);

    return _possibleConstructorReturn(this, (VideoFeedItem.__proto__ || Object.getPrototypeOf(VideoFeedItem)).apply(this, arguments));
  }

  _createClass(VideoFeedItem, [{
    key: 'renderVideos',
    value: function renderVideos() {
      var _this2 = this;

      return this.props.content.item.videos.map(function (video, index) {
        var feedUser = void 0;
        if (video.relatedFeedUserId) {
          feedUser = _this2.props.feedUsers.find(function (user) {
            return user.feedUserId.relatedId === video.relatedFeedUserId.relatedId && user.feedUserId.type === video.relatedFeedUserId.type;
          });
        }

        return _react2.default.createElement(_sharedVideo2.default, _extends({ key: index,
          adTag: _this2.props.adTag,
          communityContentId: _this2.props.content.communityContentId,
          currentUserId: _this2.props.currentUserId,
          feedContentId: _this2.props.feedContentId,
          logData: _this2.props.logData,
          onVideoOverlayClick: _this2.props.onVideoOverlayClick,
          relatedFeedUser: feedUser
        }, video));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.content.item;
      var videos = this.renderVideos();

      return _react2.default.createElement(
        _feedItemContainer2.default,
        _extends({ className: 'shared-video',
          date: this.props.displayDate,
          title: item.action
        }, this.props),
        item.description && _react2.default.createElement(_feedItemMessage2.default, { description: item.description }),
        _react2.default.createElement(
          'div',
          { className: 'feedattachments' },
          _react2.default.createElement(
            'div',
            { className: 'feedattachments-wrapper' },
            _react2.default.createElement(
              'div',
              { className: 'content' },
              videos
            )
          )
        ),
        !!item.linkTitle && _react2.default.createElement(
          'div',
          {
            className: 'feeditem-link uni-btn--subtle uni-btn--medium uni-btn--block uni-margin--one--top',
            onClick: this.props.onFeedLinkClick },
          _react2.default.createElement(
            'a',
            { href: item.linkUrl },
            _react2.default.createElement(
              'span',
              null,
              item.linkTitle
            )
          )
        )
      );
    }
  }]);

  return VideoFeedItem;
}(_react.PureComponent);

VideoFeedItem.propTypes = {
  addReactionButton: _react.PropTypes.element,
  adTag: _propTypes.adTagShape,
  author: _react.PropTypes.object.isRequired,
  content: _react.PropTypes.shape({
    communityContentId: _propTypes.CommunityContentId,
    item: _react.PropTypes.shape({
      action: _react.PropTypes.string,
      attachments: _react.PropTypes.arrayOf(_react.PropTypes.shape({
        attachmentId: _react.PropTypes.string.isRequired,
        fileName: _react.PropTypes.string.isRequired
      })),
      description: _react.PropTypes.string.isRequired,
      linkTitle: _react.PropTypes.string,
      linkUrl: _react.PropTypes.string,
      videos: _react.PropTypes.arrayOf(Object)
    }).isRequired,
    showReactions: _react.PropTypes.boolean
  }).isRequired,
  currentUserId: _react.PropTypes.string,
  displayDate: _react.PropTypes.string.isRequired,
  feedContentId: _react.PropTypes.string.isRequired,
  feedUsers: _react.PropTypes.arrayOf(_propTypes.FeedUser),
  logData: _react.PropTypes.object,
  onFeedLinkClick: _react.PropTypes.func,
  onVideoOverlayClick: _react.PropTypes.func,
  reactionComponent: _react.PropTypes.element,
  shareButton: _react.PropTypes.element,
  isSponsored: _react.PropTypes.bool
};
exports.default = VideoFeedItem;